import * as React from "react";
import { cn } from "@/lib/utils";

type Props = {
  className?: string;
  /** Turbulence base frequency — higher = finer noise. */
  baseFrequency?: number;
  /** 0..1 opacity of the noise layer. */
  opacity?: number;
  /** Blend mode for the noise layer. */
  blend?: "soft-light" | "overlay" | "screen" | "multiply" | "normal";
};

/**
 * Aceternity noise-background: a fine grainy SVG feTurbulence texture
 * laid on top of any container. Sits inside a relative parent and
 * fills it absolutely. Pointer-events: none.
 */
export function NoiseBackground({
  className,
  baseFrequency = 0.85,
  opacity = 0.18,
  blend = "soft-light"
}: Props) {
  const id = React.useId();
  return (
    <div
      aria-hidden
      className={cn("absolute inset-0 pointer-events-none", className)}
      style={{ mixBlendMode: blend, opacity }}
    >
      <svg width="100%" height="100%" className="absolute inset-0">
        <filter id={`n-${id}`}>
          <feTurbulence
            type="fractalNoise"
            baseFrequency={baseFrequency}
            numOctaves="3"
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter={`url(#n-${id})`} />
      </svg>
    </div>
  );
}
